import { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ModuleFormat } from 'shared/constants/ModuleFormat';
import { LayoutConst } from 'core';

type BadgeFormat = ModuleFormat.Online | ModuleFormat.PreRecorded | ModuleFormat.Offline;

export interface CourseFormatBadgeProps {
  format: BadgeFormat;
}

const BADGE_TEXT_KEYS: Record<BadgeFormat, string> = {
  [ModuleFormat.Online]: 'lms_course_format_badge_online',
  [ModuleFormat.PreRecorded]: 'lms_course_format_badge_prerecorded',
  [ModuleFormat.Offline]: 'lms_course_format_badge_offline',
};

const BADGE_COLORS: Record<BadgeFormat, string> = {
  [ModuleFormat.Online]: '#1F1F1F',
  [ModuleFormat.PreRecorded]: '#4F7B62',
  [ModuleFormat.Offline]: '#4F627B',
};

const Badge = styled.div<{ $format: BadgeFormat }>`
  font-family: Druk Cy;
  min-width: 80px;
  height: 31px;
  display: inline-flex;
  align-items: center;
  justify-content: right;
  font-size: 21px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #fff;
  background: ${({ $format }) => BADGE_COLORS[$format]};
  white-space: nowrap;
  padding: 0 8px 0 12px;

  @media(max-width: ${LayoutConst.screen.l}px) {
    min-width: 56px;
    height: 23px;
    font-size: 15px;
    line-height: 14px;
  }
`;

export const CourseFormatBadge: FC<CourseFormatBadgeProps> = ({ format }) => {
  const { t } = useTranslation();
  const key = BADGE_TEXT_KEYS[format];
  if (!key) return null;
  return <Badge $format={format}>{t(key)}</Badge>;
};
import { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ModuleFormat } from 'shared/constants/ModuleFormat';
import { LayoutConst } from 'core';

type BadgeFormat = ModuleFormat.Online | ModuleFormat.PreRecorded | ModuleFormat.Offline;

export interface CourseFormatBadgeProps {
  format: BadgeFormat;
}

const BADGE_TEXT_KEYS: Record<BadgeFormat, string> = {
  [ModuleFormat.Online]: 'lms_course_format_badge_online',
  [ModuleFormat.PreRecorded]: 'lms_course_format_badge_prerecorded',
  [ModuleFormat.Offline]: 'lms_course_format_badge_offline',
};

const BADGE_COLORS: Record<BadgeFormat, string> = {
  [ModuleFormat.Online]: '#1F1F1F',
  [ModuleFormat.PreRecorded]: '#4F7B62',
  [ModuleFormat.Offline]: '#4F627B',
};

const Badge = styled.div<{ $format: BadgeFormat }>`
  font-family: Druk Cy;
  min-width: 80px;
  height: 31px;
  display: inline-flex;
  align-items: center;
  justify-content: right;
  font-size: 21px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #fff;
  background: ${({ $format }) => BADGE_COLORS[$format]};
  white-space: nowrap;
  padding: 0 8px 0 12px;

  @media(max-width: ${LayoutConst.screen.l}px) {
    min-width: 56px;
    height: 23px;
    font-size: 15px;
    line-height: 14px;
  }
`;

export const CourseFormatBadge: FC<CourseFormatBadgeProps> = ({ format }) => {
  const { t } = useTranslation();
  const key = BADGE_TEXT_KEYS[format];
  if (!key) return null;
  return <Badge $format={format}>{t(key)}</Badge>;
};
